import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";

import { PageComponent, CategoryItemComponent, LabeledContainerComponent } from "@shared/components";
import { CacheId } from "@shared/enums";
import { CategoryItem } from "@shared/models";

@Component({
  selector: "app-charts",
  standalone: true,
  imports: [PageComponent, CategoryItemComponent, LabeledContainerComponent],
  templateUrl: "./charts.component.html",
  styleUrl: "./charts.component.scss",
})
export class ChartsComponent {
  router = inject(Router);

  timeCharts: CategoryItem[] = [
    { icon: { icon: "pi pi-chart-bar", class: "icon red" }, label: "IMAX", route: "imax" },
    { icon: { icon: "pi pi-chart-bar", class: "icon orange" }, label: "PROJ", route: "proj" },
    { icon: { icon: "pi pi-chart-bar", class: "icon yellow" }, label: "VMAX", route: "vmax" },
  ];

  dayCharts: CategoryItem[] = [
    { icon: { icon: "pi pi-chart-bar", class: "icon green" }, label: "Work", route: "work" },
    { icon: { icon: "pi pi-chart-bar", class: "icon blue" }, label: "PVDs", route: "pvds" },
    { icon: { icon: "pi pi-chart-bar", class: "icon indigo" }, label: "Training", route: "training" },
    { icon: { icon: "pi pi-chart-bar", class: "icon purple" }, label: "Sick", route: "sick" },
  ];

  navigateToChart(routeParam: string | undefined): void {
    if (routeParam) {
      this.router.navigate(["charts", routeParam]);
    }
  }
}
